import type { ShortcutIcon } from "@/lib/dashboard-home/shortcuts";
import { cn } from "@/lib/utils";
import type { ReactNode } from "react";
import { SHORTCUT_ICONS } from "./shortcut-icons";

/**
 * Pastille de raccourci de la maquette (verre clair, lisible sur tout fond).
 * Un libellé long passe à la ligne : le rayon fixe garde la forme de pilule
 * sur une ligne sans faire de gros arrondis sur plusieurs.
 */
export const ShortcutPill = ({
  icon,
  label,
  className,
  before,
  after,
}: {
  icon: ShortcutIcon;
  label: string;
  className?: string;
  before?: ReactNode;
  after?: ReactNode;
}) => {
  const Icon = SHORTCUT_ICONS[icon];
  return (
    <span
      className={cn(
        "flex min-w-0 items-center gap-2.5 rounded-[1.25rem] border border-slate-200 bg-white/70 px-3 py-2 text-slate-900 backdrop-blur-[50px]",
        className,
      )}
    >
      {before}
      <Icon className="size-4 shrink-0 text-primary" aria-hidden />
      <span className="min-w-0 flex-1 text-left text-sm font-medium leading-snug [overflow-wrap:anywhere]">
        {label}
      </span>
      {after}
    </span>
  );
};
